<template>
  <div class="download-box">
    <!-- 顶部标题 -->
    <div class="header-title">
      <img class="logo" src="../../assets/images/entryThemeOne/logo-orange.png" />
    </div>
    <h1 class="main-title">
      <img src="../../assets/images/entryThemeOne/result-loan-user.png" alt="" />
    </h1>
    <!-- 主内容区域 -->
    <div class="main-content u-text-center">
      <div class="trapezoid">安全合规</div>
      <!-- 金额 -->
      <div class="auth-success">
        <p>最高可借额度(元)</p>
        <h2>200,000</h2>
      </div>

      <!-- 步骤 -->
      <div class="benefit-cards">
        <img src="../../assets/images/entryThemeOne/result-loan-step.png" alt="" />
      </div>

      <!-- 下载按钮 -->
      <van-button class="download-btn" type="default" @click="onUserDownloadClick">
        <img class="download-icon" src="../../assets/images/entryThemeOne/down-vector.png" alt="" />
        <!-- 下载操作改为用户主动触发，结果页不再自动倒计时跳转。 -->
        <span>下载APP 匹配更多资金</span>
      </van-button>
      <p class="download-tips">*页面额度仅供参考，实际下款金额以最终审批为准</p>
    </div>

    <!-- 温馨提示 -->
    <div class="tips-section">
      <p class="tips-text">
        温馨提示：未经您的明示许可，本平台不会对您的个人信息进行任何处理行为。请谨防第三方短信、电话诈骗，确保您的隐私与资金安全
      </p>
    </div>

    <!-- 3步完成借款 -->
    <div class="steps-section">
      <div class="steps-title">
        <img
          class="header-line left"
          src="../../assets/images/entryThemeOne/header-line.png"
          alt=""
        />
        <span class="steps-title-text">产品优势</span>
        <img class="header-line" src="../../assets/images/entryThemeOne/header-line.png" alt="" />
      </div>
      <div class="steps-container">
        <div class="step-item">
          <div class="step-icon">
            <img src="../../assets/images/entryThemeOne/step_2.png" alt="" />
          </div>
          <div class="step-text">灵活额度</div>
        </div>
        <div class="step-arrow">
          <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
        </div>
        <div class="step-item">
          <div class="step-icon">
            <img src="../../assets/images/entryThemeOne/step_3.png" alt="" />
          </div>
          <!-- 合规调整：使用中性流程名称，不承诺审批速度。 -->
          <div class="step-text">资料审核</div>
        </div>
        <div class="step-arrow">
          <img src="../../assets/images/entryThemeOne/step_arrow.png" alt="" />
        </div>
        <div class="step-item">
          <div class="step-icon">
            <img src="../../assets/images/entryThemeOne/step_4.png" alt="" />
          </div>
          <div class="step-text">安全保障</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as API_Common from '@/api/common.js'
export default {
  name: 'DownloadApp',
  data() {
    return {
      channel: this.$route.query.source, // 渠道标识
      brand: this.$route.query.brand, // 设备型号
      downAppUrl: undefined, // 下载地址
    }
  },
  created() {
    window.__TRACK_SCENE_KEY__ = 'resultLoanThemeOne'
  },
  mounted() {
    API_Common.handleBatchTrackBase(100056)

    this.getDownloadUrl()
  },
  methods: {
    // 检查是否在微信中
    isWeixin() {
      var ua = navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    // 下载按钮点击
    handleDownload() {
      let isWeixin = this.isWeixin()
      if (isWeixin) {
        this.showPop = true
      } else {
        if (this.brand === 'xiaomi') {
          window.location.href = 'https://app.xiaomi.com/detail/1500555'
        } else {
          window.location.href = this.downAppUrl
        }
      }
    },
    onUserDownloadClick() {
      API_Common.handleBatchTrackBase(100057)

      this.handleDownload()
    },

    // 获取下载地址
    getDownloadUrl() {
      API_Common.getDownloadUrl(this.channel).then((res) => {
        if (res.code === 200) {
          this.downAppUrl = res.data.url
        } else {
          this.$toast.fail('获取下载地址失败,请重试')
        }
      })
    },
    trackTl5ThemeOneBase(eventType) {
      API_Common.handleBatchTrackBase(eventType)
    },
  },
  beforeDestroy() {
    window.__TRACK_SCENE_KEY__ = ''
  },
}
</script>

<style lang="scss" scoped>
.download-box {
  min-height: 100vh;
  background-image: url('../../assets/images/entryThemeOne/result-loan-bg.png');
  background-size: 100% 6rem;
  background-repeat: no-repeat;
  background-color: #f5f5f5;
  font-size: 0.24rem;
  padding: 0.1rem 0.3rem;

  // 顶部标题
  .header-title {
    padding: 0.3rem 0;

    .logo {
      width: 4rem;
      height: auto;
      margin-bottom: 0.16rem;
    }

    .title-text {
      font-size: 0.28rem;
      font-weight: 500;
      color: #333;
    }
  }

  // 主内容区域
  .main-title {
    font-size: 0.48rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 0.6rem;
    text-align: center;
    img {
      width: 100%;
      height: auto;
    }
    .amount {
      color: #ff5713;
    }
  }
  .main-content {
    padding: 0.01rem 0.3rem 0.5rem;
    background: linear-gradient(180deg, #ffebdf 0%, #fffefd 21.48%, #fffdfc 100%);
    border: 1px solid #fff;
    border-radius: 0.16rem;
    box-shadow: 0 0.08rem 0.24rem rgba(0, 0, 0, 0.05);

    // 圆角梯形
    .trapezoid {
      display: inline-block;
      position: relative;
      padding: 0.14rem 1rem;
      background: #ffba9160;
      color: #6c2e08;
      font-size: 0.28rem;
      font-weight: 500;
      margin-bottom: 0.4rem;
      border-radius: 0 0 0.6rem 0.6rem;

      // 使用clip-path创建圆角梯形效果
      clip-path: polygon(0% 0%, 100% 0%, 90% 100%, 10% 100%);

      // 调整文字样式
      text-align: center;
      line-height: 1.4;
      // box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }

    // 成功图标
    .success-icon {
      margin-bottom: 0.4rem;
      img {
        width: 1.4rem;
        height: auto;
      }
      .icon-circle {
        width: 1.2rem;
        height: 1.2rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto;
      }
    }

    // 认证成功提示
    .auth-success {
      margin-bottom: 0.6rem;

      h2 {
        font-size: 0.8rem;
        font-weight: 600;
        color: #333;
        margin-bottom: 0.16rem;
      }

      p {
        font-size: 0.28rem;
        color: #666;
        margin-bottom: 0.5rem;
      }
    }

    // 福利卡片
    .benefit-cards {
      display: flex;
      justify-content: center;
      margin-bottom: 0.6rem;
      img {
        width: 6rem;
        height: auto;
      }
    }

    // 下载按钮
    .download-btn {
      width: 100%;
      height: 1rem;
      background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
      border-radius: 0.5rem;
      font-size: 0.32rem;
      font-weight: 500;
      color: white;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.24rem;
      .download-icon {
        width: 0.32rem;
        height: auto;
      }
      span {
        margin-left: 0.12rem;
      }
    }

    .download-tips {
      font-size: 0.24rem;
      color: #999;
    }
  }

  // 温馨提示
  .tips-section {
    padding: 0.2rem;
    margin-bottom: 0.6rem;
    background: #fffbf9;
    border-radius: 0.24rem;
    margin: 0.3rem 0;
    .tips-text {
      font-size: 0.22rem;
      color: #75280b;
      line-height: 1.5;
      text-align: left;
    }
  }

  // 流程步骤
  .process-steps {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 0.4rem;

    .step-item {
      display: flex;
      flex-direction: column;
      align-items: center;

      .step-icon {
        width: 0.6rem;
        height: 0.6rem;
        background: linear-gradient(135deg, #ff6b35 0%, #ff9e45 100%);
        border-radius: 50%;
        color: white;
        font-size: 0.28rem;
        font-weight: 600;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 0.12rem;
      }

      .step-text {
        font-size: 0.22rem;
        color: #666;
      }
    }

    .step-arrow {
      margin: 0 0.1rem;
      color: #999;
    }
  }

  /* 3步完成借款 */
  .steps-section {
    background: linear-gradient(180deg, #fff9f6 0%, #ffffff 16.39%, #ffffff 100%);
    margin: 0.32rem 0;
    padding: 0.4rem;
    border-radius: 0.24rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

    .steps-title {
      font-size: 0.32rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 0.32rem;
      color: #333;
      .header-line {
        width: 1rem;
        height: 0.1rem;
        margin-bottom: 0.15rem;
        &.left {
          transform: rotate(180deg);
        }
      }
      .steps-title-text {
        margin: 0 0.2rem;
      }
    }

    .steps-container {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .step-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        flex: 1;

        .step-icon {
          width: 0.7rem;
          height: 0.7rem;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 0.16rem;

          img {
            width: 100%;
            height: 100%;
          }
        }

        .step-text {
          font-size: 0.2rem;
          font-weight: 600;
          color: #4b2209;
        }
      }

      .step-arrow {
        flex: 0.5;
        display: flex;
        justify-content: center;

        img {
          width: 0.7rem;
          height: 0.16rem;
          margin-bottom: 0.4rem;
        }
      }
    }
  }
}
</style>
